import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import ProfilePage from '@/pages/Profile/ProfilePage.vue'
import ProfileEdit from '@/pages/Profile/ProfileEdit.vue'

// @ts-ignore
import messages from '@/lang/index';

const profile: RouteConfig = {
  path: '/profile',
  name: 'profile',
  meta: {
    pageName: messages.employees.page_name
  },
  component: DashboardLayout,
  redirect: '/profile/page',
  children: [
    {
      path: 'page',
      name: 'profilePage',
      meta: {
        pageName: messages.labels.my_profile
      },
      component: ProfilePage
    },
    {
      path: 'edit',
      name: 'profileEdit',
      meta: {
        pageName: messages.labels.edit_my_profile
      },
      component: ProfileEdit
    }
  ]
}
export default profile;